import {IText} from "../../interface";

export const AboutProductText : IText = {
    title : "О продукте",
    text : 'DECK.AIR – система автоматизации и оцифровки всех бизнес-процессов передачи информации, планирования и управления ресурсами при обслуживании пассажиров и воздушных судов для Аэропортов.',
    text2 :'Глубокий исследовательский анализ и экспертность в enterprise разработке позволили нашей компании создать качественный, высокотехнологичный продукт',
    numbers : 'Ключевые цифры',
    pageInformation: 'Дополнительная информация'
}
